import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#193446",
    viewBox: "0 0 24 24",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M14.82 5.34a2.694 2.694 0 0 1-1.897-2.23h.865a.889.889 0 0 0 0-1.777h-3.554a.889.889 0 0 0 0 1.777h.912a4.488 4.488 0 0 0 3.112 3.917.889.889 0 0 0 .561-1.686Zm-1.92 8.065v-3.187a.889.889 0 0 0-1.778 0v3.554c0 .236.094.462.26.629l3.555 3.554a.888.888 0 0 0 1.256-1.257l-3.294-3.293Z"/> <path d="m21.524 6.925-2.666-2.666a.889.889 0 0 0-1.256 1.257l.705.704-.677.677a8.861 8.861 0 0 0-11.239 0l-.677-.677.705-.704a.889.889 0 0 0-1.256-1.257L2.497 6.925A.889.889 0 1 0 3.753 8.18l.705-.704.677.676a8.885 8.885 0 1 0 13.751 0l.677-.677.705.705a.889.889 0 0 0 1.256-1.256ZM12.011 20.88a7.108 7.108 0 1 1 7.108-7.108 7.116 7.116 0 0 1-7.108 7.108Z"/>' }
  })
);